module.exports = __webpack_public_path__ + "img/menu.b190785e.png";